import { FormControl, FormControlLabel, FormHelperText, Switch } from '@mui/material';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

type Props = {
  name: string;
  label: string;
  helperText?: string;
  disabled?: boolean;
  forcedValue?: boolean; // if defined, use this value instead of the field value
};

const VNSwitch = ({ name, label, helperText, disabled, forcedValue }: Props) => {
  const { setValue, watch, control } = useFormContext();
  const isForceValue = forcedValue !== undefined;
  const myValue = watch(name);

  useEffect(() => {
    if (myValue === null) setValue(name, false);
  }, []);

  return (
    <div className="vn-switch">
      <FormControl>
        <Controller
          name={name}
          control={control}
          defaultValue={false}
          render={({ field }) => (
            <div>
              <FormControlLabel
                label={label}
                labelPlacement="start"
                control={
                  <Switch
                    className="fuel-switch"
                    size="small"
                    {...field}
                    checked={Boolean(isForceValue ? forcedValue : myValue)}
                    disabled={disabled}
                  />
                }
              />
              {helperText && <FormHelperText id="country-helper">{helperText}</FormHelperText>}
            </div>
          )}
        />
      </FormControl>
    </div>
  );
};

export default VNSwitch;
